export default __webpack_public_path__ + "static/media/Agriculture_MARK_MASTER_Std_Colour.38a6f95b.png";